let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Nxfg")).then(() => parcelRequire('aYPbA'));